import React from 'react';
import { Handle, Position } from 'reactflow';
import { PlayCircle } from 'lucide-react';

interface StartNodeData {
  label?: string;
}

export default function StartNode({ data }: { data: StartNodeData }) {
  return (
    <div className="relative group">
      {/* Main node body */}
      <div className="
        w-12 h-12 rounded-full
        bg-status-online/20 dark:bg-status-online/30
        border-2 border-status-online
        shadow-md hover:shadow-lg
        transition-all duration-fast
        flex items-center justify-center
      ">
        <PlayCircle className="w-6 h-6 text-status-online" />
      </div>

      {/* Label */}
      <div className="
        absolute -bottom-5 left-1/2 -translate-x-1/2
        text-[10px] font-medium
        text-muted-foreground
        whitespace-nowrap
      ">
        {data.label || 'START'}
      </div>

      {/* Connection Handle */}
      <Handle
        type="source"
        position={Position.Bottom}
        className="
          !w-3 !h-3 !border-2
          !bg-status-online !border-status-online
          transition-transform hover:scale-125
        "
        style={{ bottom: '-6px' }}
      />
    </div>
  );
}

